import {
  Actions,
  Subjects,
  useIsRbacEnabled,
  useIsTeamMultiSeat,
  useUserAbilitiesContext,
} from 'context/user/UserContext';

export const useCanUseTeamView = () => {
  const isTeamUser = useIsTeamMultiSeat();

  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();

  const canTeamViewLegacy = isTeamUser;
  const canTeamViewRbac = ability.can(Actions.Read, Subjects.TeamWorkspace);

  return isRbacEnabled ? canTeamViewRbac : canTeamViewLegacy;
};

export default { useCanUseTeamView };
